module.exports = __webpack_public_path__ + "img/swish-logo.8d20f646.svg";